module.exports = __webpack_public_path__ + "img/sk_meals_guide.e6cc796b.jpg";